import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../../../shared/components/customExpandableTable';
import BookingService from './../../../../../services/cargobooking.service';
import DatePicker from 'vue2-datepicker';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import cargobookingService from './../../../../../services/cargobooking.service';
import { data } from 'jquery';

export default {
  name: 'abfrlcustomerdetails',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CustomExpandableTable,
  },
  props: ['parentObj'],
  data: function() {
    return {
      isLoading:false,
      customerName: '',
      consigneeCode1: '',
      zipCode: '',
      channel2: '',
      city: '',
      address: '',
      state: '',
      customerErr:'',
      consigneeErr:'',
      zipcodeErr:'',
      ChannelErr:'',
      cityErr:'',
      stateErr:'',
      addressErr:'',
      disabled : false
    }
  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if(this.parentObj.action == 'edit'){
      this.disabled = true;
      await this.GetAbfrlCustomerData();
    }
    this.isLoading = false;
 },
  methods:{
    isIntegerOnly: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
    async GetAbfrlCustomerData(){
      try {
        let input = {
          id:this.parentObj.id
        }
        let data = await BookingService.GetAbfrlCustomerData(input)
        if(data.data.code == 200){
          let result = data.data.data.rows[0]
          this.customerName = result.customername
          this.consigneeCode1 = result.consigneecode1
          this.zipCode = result.zipcode
          this.channel2 = result.channel2
          this.city = result.city
          this.address = result.address
          this.state = result.state
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkErr(){
      let err = 0
      if(!this.customerName){
        this.customerErr = "Please Enter Customer Name"
        err = 1
      }else{
        this.customerErr = ""
      }
      if(!this.consigneeCode1){
        this.consigneeErr = "Please Enter Consignee Code"
        err = 1
      }else{
        this.consigneeErr = ""
      }
      if(!this.zipCode){
        this.zipcodeErr = "Please Enter Zip Code"
        err = 1
      }else if(this.zipCode == 0){
        this.zipcodeErr = "Please Enter Valid Zip Code"
        err = 1
      }else{
        this.zipcodeErr = ""
      }
      // if(!this.channel2){
      //   this.ChannelErr = "Please Enter Channel1 "
      //   err = 1
      // }else{
      //   this.ChannelErr = ""
      // 
      // }
      if(!this.city){
        this.cityErr = "Please Enter City Name"
        err = 1
      }else{
        this.cityErr = ""
      }
      if(!this.state){
        this.stateErr = "Please Enter State "
        err = 1
      }else{
        this.stateErr = ""
      }
      if(!this.address){
        this.addressErr = "Please Enter Address"
        err = 1
      }else{
        this.addressErr = ""
      }
      return err
    },
    async saveData(){
      try {
        if(this.checkErr()){
          return false
        }
        this.isLoading = true
        let input = {
          action:'create',
          customername:this.customerName,
          consigneecode:this.consigneeCode1,
          zipcode:this.zipCode,
          state:this.state,
          channel:this.channel2,
          address:this.address,
          city:this.city,
          lastmodifiedby:this.userName
        }
        let create = await cargobookingService.SaveAbfrlCustomerData(input);
        if(create.data.code == 200){
          this.$alertify.success("Record Created Successfully");
          this.clearData();
          this.isLoading = false
          }else{
            this.$alert(create.data.message, "", "error");
          this.isLoading = false
          }
      } catch (error) {
        console.log(error);
      }
    },
   async updateData(){
      try {
        if(this.checkErr()){
          return false
        }
        this.isLoading = true
        let input = {
          action:'update',
          customername:this.customerName,
          consigneecode:this.consigneeCode1,
          zipcode:this.zipCode,
          state:this.state,
          channel:this.channel2?this.channel2:"",
          address:this.address,
          city:this.city,
          id:this.parentObj.id,
          lastmodifiedby:this.userName
        }
        let update = await cargobookingService.SaveAbfrlCustomerData(input)
        if(update.data.code == 200){
        this.$alertify.success("Record Updated Successfully");
        this.isLoading = false
        }else{
          this.$alert(update.data.message, "", "error");
        this.isLoading = false
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false
      }
    },
    showCustomerListing(){
      this.$emit("goBackToParent")
    },
    clearData(){
      this.customerName = ""
      this.zipCode = ""
      this.channel2 = ""
      this.city = ""
      this.address = ""
      this.state = ""
      this.customerErr = '';
      this.zipcodeErr = '';
      this.ChannelErr = '';
      this.cityErr = '';
      this.stateErr = '';
      this.addressErr = '';
      if(this.parentObj.action == 'create'){
        this.consigneeCode1 = ""
        this.consigneeErr = '';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/abfrlLogs/abfrlcustomerdetails/abfrlcreatecustomer/abfrlCreateCustomer.component.js